<template>
  <router-view></router-view>
</template>

<script>
import firebase from '@firebase/app'

function isPWA() {
  return window && window.matchMedia("(display-mode: standalone)").matches;
}

export default {
  metaInfo: {
    changed(metaInfo) {
      if(metaInfo.title && process.env.NODE_ENV === 'production') {
        firebase.analytics().setCurrentScreen(metaInfo.title);
        firebase.analytics().logEvent("page_view");
        firebase.analytics().logEvent("screen_view", {
          app_name: isPWA() ? "pwa" : "web",
          screen_name: metaInfo.title,
          app_version: process.env.PACKAGE_VERSION
        });
      }  
    }
  },
  methods: {
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    }
  },
  mounted() {
    this.initializeLayout();
  }
};
</script>
